var exports = {
  "t": "blankslateContainer__F6-V7J",
  "x": "blankslateContent__21OWZ0",
};

module.exports = exports;
